<template>
    <div
        class="wrapper outer"
        :class="{ 'ea-brand-shell': fullBleedBrand }"
    >
        <div
            class="wrapper inner"
            :class="{ 'ea-brand-shell__inner': fullBleedBrand }"
        >
            <PrimarySidebar />
            <div class="page" :class="{ 'ea-brand-page': fullBleedBrand }">
                <div class="content" :class="{ 'ea-brand-content': fullBleedBrand }">
                    <ModalGeneric />
                    <div class="tela-principal" :class="{ 'ea-brand-tela': fullBleedBrand }">
                        <div
                            class="page-wrapper primary"
                            id="dvPageWrapperPrimary"
                            :class="{ 'ea-brand-wrapper': fullBleedBrand }"
                        >
                            <section
                                class="section page-body primary special"
                                :class="{ 'ea-brand-section': fullBleedBrand }"
                            >
                                <div
                                    class="page-body-wrapper primary"
                                    :class="{ 'ea-brand-body': fullBleedBrand }"
                                >
                                    <Toolbar />
                                    <slot />
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PrimarySidebar from '@/components/primarySidebar.vue';
import ModalGeneric from '@/components/modals/modalGeneric.vue';
import Toolbar from '@/components/toolbarHeader.vue';

export default {
    name: 'AuthenticatedShell',
    components: {
        PrimarySidebar,
        ModalGeneric,
        Toolbar
    },
    props: {
        /** Layout 100% viewport + fundo marca (telas de configuração). */
        fullBleedBrand: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss">
/* Sem scoped: encadeia com classes globais do layout. */
/* Mesmo “caixa” da home: body .wrapper.outer no css-master (max 1920px, centralizado) */
.ea-brand-shell {
    margin-left: auto !important;
    margin-right: auto !important;
    max-width: 1600px !important;
    min-height: 100vh;
    background: #0b0b0d;
}

.ea-brand-shell .ea-brand-shell__inner {
    min-height: 100vh;
    align-items: stretch;
}

.ea-brand-shell .ea-brand-page {
    flex: 1 1 auto;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    width: 100% !important;
    background: #0b0b0d;
}

.ea-brand-shell .ea-brand-content {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 !important;
}

.ea-brand-shell .ea-brand-tela {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.ea-brand-shell .ea-brand-wrapper {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: none !important;
}

.ea-brand-shell .ea-brand-section {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.ea-brand-shell .ea-brand-body {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
}

.ea-brand-shell .ea-brand-body > .navbar.primary {
    flex-shrink: 0;
    padding: 0.75rem 1.25rem 0 !important;
    display: flex !important;
    justify-content: flex-end !important;
    align-items: center !important;
    width: 100% !important;
    left: auto !important;
    transform: none;
}

.ea-brand-shell .ea-brand-body > .navbar.primary .container {
    max-width: none !important;
    width: 100% !important;
}

/* Sobrescreve css-master: faixa útil full width; o bloco de conteúdo limita em .ea-config-layout */
.ea-brand-shell .page .page-wrapper.primary .page-body.primary .page-body-wrapper.primary {
    max-width: none !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 100% !important;
}

/* Conteúdo config: ocupa 100% da faixa útil (largura + altura flex sob a toolbar) */
.ea-brand-shell .ea-brand-body > .ea-config-layout {
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
    max-width: none !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    align-self: stretch;
    box-sizing: border-box;
}

/* Evita rolagem dupla na área .page-body (scroll só no conteúdo interno) */
.ea-brand-shell .page .page-wrapper.primary .page-body.primary {
    overflow: hidden !important;
}

.ea-brand-shell .page .page-wrapper.primary .page-body.primary.special {
    height: auto !important;
    min-height: 0 !important;
    flex: 1 1 auto;
    max-height: none;
    overflow: hidden !important;
    padding: 0.75rem clamp(0.75rem, 2vw, 1.25rem) 1rem !important;
}
</style>
